import type { SVGProps } from "react";
export interface HomeStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HomeStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HomeStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.878 8.454a1.376 1.376 0 0 1 2.243 0l.106.177.838 1.667 1.882.27.199.043c.961.284 1.349 1.538.557 2.297l-1.35 1.292.318 1.822c.202 1.16-1.016 1.949-1.983 1.45l-1.689-.872-1.686.871c-.968.5-2.185-.29-1.983-1.449l.316-1.822-1.35-1.292c-.844-.81-.346-2.183.757-2.34l1.882-.27.838-1.667zm.803 3.38c-.165.33-.48.558-.845.61l-.672.095.473.453c.27.259.393.636.33 1.005l-.116.663.632-.326.125-.056c.295-.11.625-.09.908.056l.633.326-.116-.663c-.064-.37.06-.746.331-1.005l.472-.453-.671-.095a1.13 1.13 0 0 1-.847-.61L12 11.2l-.318.635Z"
      />
      <path
        fill={color}
        d="M19.875 10.5c0-.59-.278-1.146-.75-1.5l-6-4.5c-.667-.5-1.583-.5-2.25 0l-6 4.5c-.472.354-.75.91-.75 1.5V18c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 7.5A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18v-7.5c0-1.298.61-2.521 1.65-3.3l6-4.5a4.13 4.13 0 0 1 4.95 0l6 4.5a4.13 4.13 0 0 1 1.65 3.3z"
      />
    </svg>
  );
}
